/// <reference types="grecaptcha" />
import '@ts/pages/page-defaults';
const nlForm = document.getElementById('newsletter-form');
if (nlForm) {
    const sitekey = nlForm.getAttribute('data-recaptcha-sitekey') ?? '';
    nlForm.addEventListener('submit', (e) => {
        e.preventDefault();
        const submitBtn = nlForm.querySelector('#submit-btn');
        if (submitBtn)
            submitBtn.disabled = true;
        const emailInput = nlForm.querySelector('input[name="email_for_newsletter"]');
        if (emailInput)
            emailInput.readOnly = true;
        grecaptcha.ready(() => {
            grecaptcha.execute(sitekey, { action: 'newsletter_subscribe' }).then((token) => {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = 'captcharesponse';
                input.value = token;
                nlForm.appendChild(input);
                nlForm.submit();
            });
        });
    });
}
